export default __webpack_public_path__ + "static/provider-51530f1239d99d31d80440acf8b4b305.png";